import { Field, ImageField, LinkField, TextField } from '@sitecore-jss/sitecore-jss-nextjs';
import { LinkFieldValue } from '@sitecore-jss/sitecore-jss-react/types/components/Link';

import * as icons from '@gn-audio/icons';

import {
  SitecoreCustomStyle,
  SitecoreFieldTypes,
  SitecoreItem,
  TitledSitecoreItem,
} from 'common/types/sitecore';

export type MajorLinkSmallCard = SitecoreFieldTypes &
  SitecoreCustomStyle & {
    BackgroundImage: ImageField;
    backgroundImageExternalLink: LinkField;
    Header: Field<string>;
    Link: LinkField;
  };

export type MajorLinkBigCard = MajorLinkSmallCard & {
  Description: Field<string>;
};

export type CampaignCard = MajorLinkBigCard & {
  Footer: Field<string>;
};

export type SCMajorLinkCard = SitecoreItem<MajorLinkBigCard | MajorLinkSmallCard | CampaignCard>;

export type MenuItem = TitledSitecoreItem<{
  ContentReferences: SitecoreItem<{ Theme: { value: string }; ThemeShared: { value: string } }>;
  ContentReferencesShared: { value: LinkFieldValue };
}>;

export type SubmenuItem = SitecoreItem<{
  MajorLinksCategories: MajorLinksCategory[];
  MinorLinksCategories: MinorLinksCategory[];
}>;

export type MajorLinksCategory = SitecoreItem<{
  Label: Field<string>;
  MajorLinks: TitledSitecoreItem<MajorLink>[];
}>;

export type MajorLink = {
  MajorSublinks?: TitledSitecoreItem<{
    Link: LinkField;
    LinkShared: LinkField;
  }>[];
  MajorSublinksShared?: TitledSitecoreItem<{
    Link: LinkField;
    LinkShared: LinkField;
  }>[];
  Cards?: SCMajorLinkCard[];
  CardsShared?: SCMajorLinkCard[];
  Link: LinkField;
  LinkShared: LinkField;
};

export type MinorLink = {
  Link: LinkField;
  LinkShared: LinkField;
  IconName: Field<keyof typeof icons>;
};

export type MinorLinksCategory = SitecoreItem<{
  Label: TextField;
  LabelShared: TextField;
  MinorLinks: TitledSitecoreItem<MinorLink>[];
  MinorLinksShared: TitledSitecoreItem<MinorLink>[];
}>;
